import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";

export default function standart() {}

export const FillTableCallBack = (result, page_number, columnList) => {
  var oTable = $("#example").dataTable();
  if (page_number === 1) {
    oTable.fnClearTable();
  }
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        var circleType =
          data.content["algemeen-actief"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var algemeenNaam =
          '<span class="text-dark font-weight-bold">' +
          data.content["algemeen-naam"] +
          "</span>";
        var algemeenCode =
          '<a href="javascript:void(0)">' +
          data.content["algemeen-code"] +
          "</a>";
        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';
        var bestekspost = data.content["algemeen-bestekspost"];
        if (typeof bestekspost === "undefined") {
          bestekspost = "";
        }
        var rawdeficode = data.content["algemeen-rawdeficode"];
        if (typeof rawdeficode === "undefined") {
          rawdeficode = "";
        }
        var eenheidsprijs = data.content["algemeen-eenheidsprijs"];
        if (typeof eenheidsprijs === "undefined") {
          eenheidsprijs = "";
        }
        var kwaliteit = data.content["algemeen-kwaliteit"];
        if (typeof kwaliteit === "undefined") {
          kwaliteit = "";
        }
        var omschrijving = data.content["algemeen-omschrijving"];
        if (typeof omschrijving === "undefined") {
          omschrijving = "";
        }
        var rawhoofdcode = data.content["algemeen-rawhoofdcode"];
        if (typeof rawhoofdcode === "undefined") {
          rawhoofdcode = "";
        }
        var eenheid = data.content["algemeen-eenheid"];
        if (typeof eenheid === "undefined") {
          eenheid = "";
        }
        var algemeenBtwpercentage = data.content["algemeen-btwpercentage"];
        if (typeof algemeenBtwpercentage === "undefined") {
          algemeenBtwpercentage = "";
        }
        var algemeenpercentage = data.content["algemeen-percentage"];
        if (typeof algemeenpercentage === "undefined") {
          algemeenpercentage = "";
        }

        var algemeenPeriodevoorkeurIdentification =
          data.content["algemeen-periodevoorkeur"];
        if (typeof algemeenPeriodevoorkeurIdentification === "undefined") {
          algemeenPeriodevoorkeurIdentification = "";
        }

        var algemeenPatroonvoorkeurIdentification =
          data.content["algemeen-patroonvoorkeur"];
        if (typeof algemeenPatroonvoorkeurIdentification === "undefined") {
          algemeenPatroonvoorkeurIdentification = "";
        }

        let aantalbijlagen = data.content["algemeen-aantalbijlagen"];
        if (typeof aantalbijlagen === "undefined") {
          aantalbijlagen = "";
        }

        let grootboeknummer = data.content["grootboeknummer-naam"];
        if (typeof grootboeknummer === "undefined") {
          grootboeknummer = "";
        }

        var model = {
          algemeenNaam: data.content["algemeen-naam"],
          algemeenCode: data.content["algemeen-code"],
          bestekspost: data.content["algemeen-bestekspost"],
          aantalbijlagen: aantalbijlagen,
          rawhoofdcode: data.content["algemeen-rawhoofdcode"],
          rawdeficode: data.content["algemeen-rawdeficode"],
          eenheidsprijs: data.content["algemeen-eenheidsprijs"],
          eenheid: data.content["algemeen-eenheid"],
          algemeenpercentage: data.content["algemeen-percentage"],
          kwaliteit: data.content["algemeen-kwaliteit"],
          omschrijving: data.content["algemeen-omschrijving"],
          isActive: data.content["algemeen-actief"],
          identification: data["identification"],
          algemeenPeriodevoorkeurIdentification:
            algemeenPeriodevoorkeurIdentification,
          algemeenPatroonvoorkeurIdentification:
            algemeenPatroonvoorkeurIdentification,
          algemeenBtwpercentage: algemeenBtwpercentage,
        };

        var test = {
          checkbox: checkbox,
          active: circleType,
          Naam: algemeenNaam,
          Code: algemeenCode,
          Bestekspost: bestekspost,
          paperclip: aantalbijlagen,
          "RAW Hoofdcode": rawhoofdcode,
          "RAW Deficode": rawdeficode,
          Eenheidsprijs: eenheidsprijs,
          Eenheid: eenheid,
          Percentage: algemeenpercentage,
          Kwaliteit: kwaliteit,
          Omschrijving: omschrijving,
          "Periode voorkeur": algemeenPeriodevoorkeurIdentification,
          "Patroon voorkeur": algemeenPatroonvoorkeurIdentification,
          "Grootboekrekening": grootboeknummer
        };

        let _columnList = [];
        if (columnList && columnList.column_list){
          for (let column in columnList.column_list) {
            for (let key in test) {
              if (
                  columnList.column_list[column].toLowerCase() === key.toLowerCase()
              ) {
                _columnList.push(test[key]);
              }
            }
          }
        }

        window.$catalog_measures_Glist.push(model);
        var addId = oTable.fnAddData(
          [
            ..._columnList,
            // checkbox,
            // circleType,
            // algemeenNaam,
            // algemeenCode,
            // bestekspost,
            // aantalbijlagen,
            // rawhoofdcode,
            // rawdeficode,
            // eenheidsprijs,
            // eenheid,
            // algemeenpercentage,
            // kwaliteit,
            // omschrijving,
            // algemeenPeriodevoorkeurIdentification,
            // algemeenPatroonvoorkeurIdentification,
          ],
          false
        );

        if(addId.length > 0){
          var theNode = $("#example").dataTable().fnSettings().aoData[
              addId[0]
              ].nTr;
          theNode.setAttribute("rowId", data["identification"]);
        }

      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }

  $("#total-rows").html(result.meta.total_found);
  window.$catalog_measures_column_table_total_row_count =
    result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$catalog_measures_treeChangeStatus = true;
  window.$catalog_measures_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "algemeen-code") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_measures_algemeenCode.push(data);
    });
  } else if (data.id === "algemeen-naam") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_measures_algemeenNaam.push(data);
    });
  } else if (data.id === "algemeen-bestekspost") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_measures_algemeenBestekspost.push(data);
    });
  } else if (data.id === "algemeen-kwaliteit") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_measures_algemeenKwaliteit.push(data);
    });
  } else if (data.id === "algemeen-omschrijving") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_measures_algemeenOmschrijving.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-naam") {
    console.log(result.data.values);
    window.$catalog_measures_algemeenNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_measures_algemeenNaam.push(data);
    });
  } else if (searchId === "algemeen-code") {
    window.$catalog_measures_algemeenCode.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_measures_algemeenCode.push(data);
    });
  } else if (searchId === "algemeen-bestekspost") {
    window.$catalog_measures_algemeenBestekspost.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_measures_algemeenBestekspost.push(data);
    });
  } else if (searchId === "algemeen-kwaliteit") {
    window.$catalog_measures_algemeenKwaliteit.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_measures_algemeenKwaliteit.push(data);
    });
  } else if (searchId === "algemeen-omschrijving") {
    window.$catalog_measures_algemeenOmschrijving.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_measures_algemeenOmschrijving.push(data);
    });
  }
};

// export const MaatregelenSavedCallBack = (token) => {
//   Common.sleep(800).then(() => {
//     $("#maatregelen_toevoegen_modal").modal("hide");
//     omnimap
//       .FillTableAction(
//         window.$catalog_measures_last_used_table_filter,
//         1,
//         token
//       )
//       .then((result) => {
//         FillTableCallBack(result, 1);
//       });
//   });
// };

export const MaatregelenEditCallBack = (token) => {
  Common.sleep(1500).then(() => {
    $("#detailSide").addClass("d-none");
    $("#editSide").addClass("d-none");
    $("#tableSide").removeClass("d-none");
    window.$catalog_measures_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_measures_last_used_table_filter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const RowsDeletedCallBack = (token) => {
  Common.sleep(800).then(() => {
    $("#measures-mappen_beheren_delete_modal").modal("hide");
    window.$catalog_measures_refresh()
    /*omnimap
      .FillTableAction(
        window.$catalog_measures_last_used_table_filter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const GetColumnPropertiesCallBack = (data, callType) => {
  var filteredRes = data.data.find((item, i) => {
    if (item.identification === process.env.REACT_APP_CATALOG_MEASURES) {
      return i;
    }
  });

  // var result_data =
  //   data.data[process.env.REACT_APP_NODE_ENV == "staging" ? 9 : 2].schema
  //     .properties.algemeen.properties;
  var result_data = filteredRes.schema.properties.algemeen.properties;
  window.$catalog_measures_column_list.forEach(function (item) {
    if (item.haveSelect && item.selectProperties != null) {
      if (callType == "create") {
        const selectStatus = document.getElementById(item.createId);
        while (selectStatus.firstChild) {
          selectStatus.removeChild(selectStatus.lastChild);
        }

        if (!item.createRequired) {
          var option = document.createElement("option");
          option.text = "Selecteer";
          option.style = "display:none;";
          selectStatus.add(option);
        }

        result_data[item.selectProperties].enum.forEach((element) => {
          var option = document.createElement("option");
          option.text = element;
          option.value = element;
          selectStatus.add(option);
        });
      } else if (callType == "edit") {
        const editSelectStatus = document.getElementById(item.editId);
        if (editSelectStatus && editSelectStatus.firstChild != null) {
          while (editSelectStatus.firstChild) {
            editSelectStatus.removeChild(editSelectStatus.lastChild);
          }
        }
        result_data[item.selectProperties].enum.forEach((element) => {
          if (item.editId) {
            var option = document.createElement("a");
            option.attributes.href = "javascript:void(0)";
            option.className = "popuptext-dropdown-a";
            option.name = item.editId;
            option.innerText = element;
            editSelectStatus.appendChild(option);
          }
        });
      }
    }
  });
};

export const GetColumnPropertiesForModelCallBack = (
  result,
  itemId,
  callType
) => {
  window.$catalog_measures_column_list.forEach(function (item) {
    if (item.id === itemId) {
      if (callType == "create") {
        const selectStatus = document.getElementById(item.createId);
        while (selectStatus.firstChild) {
          selectStatus.removeChild(selectStatus.lastChild);
        }
        if (!item.createRequired) {
          var option = document.createElement("option");
          option.text = "Selecteer";
          option.style = "display:none;";
        }

        selectStatus.add(option);
        result.data.forEach((element) => {
          var option = document.createElement("option");
          option.text = element.name;
          option.value = element.identification;
          selectStatus.add(option);
        });
      } else if (callType == "edit") {
        const editSelectStatus = document.getElementById(item.editId);
        if (editSelectStatus && editSelectStatus.firstChild != null) {
          while (editSelectStatus.firstChild) {
            editSelectStatus.removeChild(editSelectStatus.lastChild);
          }
        }
        result.data.forEach((element) => {
          if (item.editId) {
            var option = document.createElement("a");
            option.attributes.href = "javascript:void(0)";
            option.className = "popuptext-dropdown-a";
            option.name = item.editId;
            option.innerText = element.name;
            option.id = element.identification;
            editSelectStatus.appendChild(option);
          }
        });
      }
    }
  });
};

export const GebiedenCallback = (result) => {
  $("#gebieden-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="gebieden"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '"/>';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#gebieden-grp").append(btn);
  });
};

export const DisciplineCallback = (result) => {
  $("#discipline-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="discipline"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#discipline-grp").append(btn);
  });
};

export const GrootboekCallback = (result) => {
  $("#grootboeknummer-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="discipline"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#grootboeknummer-grp").append(btn);
  });
};
export const GrootboekCallbackForCreateMaat = (result) => {
  const selectStatus = document.getElementById("maatregelen-grootboek-nummer");
  while (selectStatus.firstChild) {
    selectStatus.removeChild(selectStatus.lastChild);
  }
  var option = document.createElement("option");
  option.text = "Selecteer";
  option.style = "display:none;";
  selectStatus.add(option);

  if (result.meta.total_found > 0) {
    result.data.forEach((element) => {
      var option = document.createElement("option");
      option.text = element.name;
      option.value = element.identification;
      selectStatus.add(option);
    });
  }
};
export const GrootboekCallbackForEditMaat = (result) => {
  const editSelectStatus = document.getElementById("e-grootboek-nummer");
  if (editSelectStatus && editSelectStatus.firstChild != null) {
    while (editSelectStatus.firstChild) {
      editSelectStatus.removeChild(editSelectStatus.lastChild);
    }
  }
  result.data.forEach((element) => {
    var option = document.createElement("a");
    option.attributes.href = "javascript:void(0)";
    option.className = "popuptext-dropdown-a";
    option.name = "e-grootboek-nummer";
    option.innerText = element.name;
    option.id = element.identification;
    editSelectStatus.appendChild(option);
  });
};
export const DisciplineCallbackForCreateMaat = (result) => {
  const selectStatus = document.getElementById("maatregelen-discipline");
  while (selectStatus.firstChild) {
    selectStatus.removeChild(selectStatus.lastChild);
  }
  var option = document.createElement("option");
  option.text = "Selecteer";
  option.style = "display:none;";
  selectStatus.add(option);

  result.data.forEach((element) => {
    var option = document.createElement("option");
    option.text = element.name;
    option.value = element.identification;
    selectStatus.add(option);
  });
};
export const DisciplineCallbackForEditMaat = (result) => {
  const editSelectStatus = document.getElementById("e-discipline");
  if (editSelectStatus && editSelectStatus.firstChild != null) {
    while (editSelectStatus.firstChild) {
      editSelectStatus.removeChild(editSelectStatus.lastChild);
    }
  }
  result.data.forEach((element) => {
    var option = document.createElement("a");
    option.attributes.href = "javascript:void(0)";
    option.className = "popuptext-dropdown-a";
    option.name = "e-discipline";
    option.innerText = element.name;
    option.id = element.identification;
    editSelectStatus.appendChild(option);
  });
};

export const GetActionsOfRowCallback = (result) => {
  var actionsOfSelection = [];
  var actionsOfDisabled = [];

  window.$catalog_measures_actions_identifications = [];
  $.each(
    result.data.stages === undefined
      ? result.data.stages_list
      : result.data.stages,
    function (index, stage) {
      if (
        stage.definition.type === "activity" &&
        (stage.start_allowed == true || stage.finish_allowed == true)
      ) {
        actionsOfSelection.push(stage.definition.identification);

        let ids = { name: stage.definition.name, id: stage.identification };
        window.$catalog_measures_actions_identifications.push(ids);
      } else {
        actionsOfDisabled.push(stage.definition);
      }
    }
  );

  $("#myPopup").html("");

  $.each(window.$catalog_measures_actions, function (index, action) {
    if ($.inArray(action["id"], actionsOfSelection) !== -1) {
      var anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: action["id"] })
        .addClass(/*action["class"] +*/ "measures-catalog-action")
        .html(action["text"]);
      $("#myPopup").append(anchor);
    }
  });
  //** aktif olmayan actionlar burada listeleniyor. */
  $.each(actionsOfDisabled, function (index, action) {
    var anchor = $("<a disabled></a>")
      .attr({ href: "javascript:void(0)", id: action["identification"] })
      .addClass("disabled" + " catalog-action")
      .html(action["name"]);
    $("#myPopup").append(anchor);
  });
  if (
    result.data.stages === undefined
      ? result.data.stages_list.length > 0
      : result.data.stages.length > 0
  ) {
    var verwijderen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "mat-verwijderen" })
      .addClass("trash-bin beheereenheid")
      .html("Verwijderen");
    $("#myPopup").append(verwijderen);
  } else {
    var beheereenheidToevoegen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "maatregelen_toevoegen" })
      .addClass("maatregelen beheereenheid")
      .html("Maatregelen toevoegen");
    $("#myPopup").append(beheereenheidToevoegen);

    var mapAanmaken = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "mat-map_aanmaken" })
      .addClass("folder-popup beheereenheid")
      .html("Map aanmaken");
    $("#myPopup").append(mapAanmaken);
  }

  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

export const MaatregelenSavedCallBack = (token) => {
  Common.sleep(1000).then(() => {
    var model = {
      action: "ADD",
      contextRol: "Maatregel zit in folder",
      folder: document.getElementById("tree-parent-id").value,
    };
    Common.StartActivity(
      model,
      [window.$catalog_measures_newInsertId],
      "290bc8a2-164d-4c73-8a01-4b9431cd6bea",
      maatregelenSavedNext(token),
      token
    );
  });
};
function maatregelenSavedNext(token) {
  Common.sleep(5000).then(() => {
    $("#maatregelen_toevoegen_modal").modal("hide");
    window.$catalog_measures_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_measures_last_used_table_filter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
}

export const StageListCallBack = (result) => {
  result.data.stages_list.forEach((stageList) => {
    window.$catalog_measures_actions_identifications.push(stageList);
  });
};

export const WorkResourcesCallBack = (result) => {
  $("#koppelen-werkbron-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="work-resource"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#koppelen-werkbron-grp").append(btn);
  });
};

export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    test_list.push(element.sTitle);
  });

  var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
  test_list[checkIndex] = "checkbox";
  var statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
  test_list[statusIndex] = "active";
  let paperIndex = test_list.findIndex((x) => x.includes("bijlage"));
  test_list[paperIndex] = "paperclip";
  var model = {
    identification: identification,
    code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    reference: columnOrderReference,
    data: {
      table_sorting: [
        {
          name: "catalog>measures",
          column_list: [],
        },
      ],
    },
  };
  var asd = (model.data.table_sorting.find(
    (x) => x.name === "catalog>measures"
  ).column_list = test_list);
  omnimap.GetFreeFormatAction(identification, "PUT", model);

  return model.data.table_sorting[0];
}
